import { ShotPerGameIcon } from '@/common/assets';
import { useNewTranslations } from '@/common/translations';

import StatisticsLabel from '../StatisticsLabel';

export default function ShotsPerGameLabel() {
  const translate = useNewTranslations();

  return (
    <div className="flex flex-1 min-h-px min-w-0 w-full max-w-full items-center justify-center gap-1.5">
      <ShotPerGameIcon
        aria-hidden
        className="pointer-events-none size-[18px] shrink-0 text-pmw-label-secondary-light dark:text-pmw-label-secondary-dark"
      />
      <StatisticsLabel className="min-w-0 flex-0 text-center line-clamp-3">
        {translate('PreMatchStats.ShotsGame')}
      </StatisticsLabel>
    </div>
  );
}
